function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m108.4 146.9c0 6.9-5.4 12.4-12.1 12.4h-66.6c-6.7 0-12.1-5.6-12.1-12.4v-134.5c0-6.8 5.4-12.4 12.1-12.4h66.6c6.7 0 12.1 5.6 12.1 12.4z",
  fill: "#fff",
  stroke: "#404041",
  strokeMiterlimit: 10,
  strokeWidth: 0.1225
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m22.2 26.4h81.5v104.5h-81.5z",
  fill: "#404041"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "m71.7 12.6c0 1.4-1.1 2.5-2.5 2.5h-12.4c-1.4 0-2.5-1.1-2.5-2.5s1.1-2.5 2.5-2.5h12.4c1.4 0 2.5 1.1 2.5 2.5z",
  fill: "#231f20"
});

var _ref5 = /*#__PURE__*/React.createElement("g", {
  fill: "#fff"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 63,
  cy: 145.1,
  r: 8,
  stroke: "#231f20",
  strokeMiterlimit: 10,
  strokeWidth: 0.1206
}), /*#__PURE__*/React.createElement("path", {
  d: "m30.9 37.8c.1.1.2.1.3.1s.2 0 .3-.1.1-.2.2-.3c0-.1.1-.2.1-.3s0-.2 0-.3c-.1.1-.2.2-.3.3s-.3.1-.4.1-.3 0-.4-.1-.3-.2-.4-.3-.2-.2-.2-.4c0-.1-.1-.3-.1-.4 0-.2 0-.3.1-.5s.1-.3.2-.4.2-.2.4-.3c.1-.1.3-.1.5-.1.3 0 .5.1.7.2s.3.2.4.4.2.4.2.6.1.4.1.6 0 .4-.1.6c0 .2-.1.4-.2.6s-.2.3-.4.4-.4.2-.6.2c-.1 0-.3 0-.4-.1-.1 0-.2-.1-.3-.2s-.2-.2-.2-.3c-.1-.1-.1-.3-.1-.4h.7c-.2.2-.1.3-.1.4zm.6-1.1c.1 0 .1-.1.2-.1 0-.1.1-.1.1-.2s0-.2 0-.2c0-.1 0-.2 0-.2 0-.1-.1-.1-.1-.2s-.1-.1-.2-.1-.1-.1-.2-.1-.2 0-.2.1c-.1 0-.1.1-.2.1 0 .1-.1.1-.1.2v.2.2c0 .1.1.1.1.2s.1.1.2.1.1.1.2.1c.1-.1.2-.1.2-.1z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m33.8 37.6v.8h-.8v-.8z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m34.2 37.6v-.6l1.5-2h.6v2h.5v.6h-.5v.8h-.7v-.8zm1.4-1.8-.9 1.2h.9z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m38.1 38.4v-2.2h-.9v-.5h.4c.1 0 .2-.1.3-.1.1-.1.2-.1.2-.2.1-.1.1-.2.1-.3h.6v3.5h-.7z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m83.9 34.5h1.8v3.9h-1.8z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m86.5 34.5h1.8v3.9h-1.8z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m89 34.5h1.8v3.9h-1.8z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m95.2 35h-.8v-1.7h-11.6v6.2h11.5v-1.7h.8v-2.8zm-1.1 4.2h-11v-5.6h11z"
}));

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "m48.7 67.5c0 1.8-1.5 3.3-3.3 3.3h-12.4c-1.8 0-3.3-1.5-3.3-3.3v-12.4c0-1.8 1.5-3.3 3.3-3.3h12.4c1.8 0 3.3 1.5 3.3 3.3z",
  fill: "#eb008b"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "m72.2 67.5c0 1.8-1.5 3.3-3.3 3.3h-12.4c-1.8 0-3.3-1.5-3.3-3.3v-12.4c0-1.8 1.5-3.3 3.3-3.3h12.4c1.8 0 3.3 1.5 3.3 3.3z",
  fill: "#8bc53f"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "m95.8 67.5c0 1.8-1.5 3.3-3.3 3.3h-12.4c-1.8 0-3.3-1.5-3.3-3.3v-12.4c0-1.8 1.5-3.3 3.3-3.3h12.4c1.8 0 3.3 1.5 3.3 3.3z",
  fill: "#faaf40"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "m48.7 91.5c0 1.8-1.5 3.3-3.3 3.3h-12.4c-1.8 0-3.3-1.5-3.3-3.3v-12.4c0-1.8 1.5-3.3 3.3-3.3h12.4c1.8 0 3.3 1.5 3.3 3.3z",
  fill: "#00a14b"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "m72.2 91.5c0 1.8-1.5 3.3-3.3 3.3h-12.4c-1.8 0-3.3-1.5-3.3-3.3v-12.4c0-1.8 1.5-3.3 3.3-3.3h12.4c1.8 0 3.3 1.5 3.3 3.3z",
  fill: "#ee4036"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "m95.8 91.5c0 1.8-1.5 3.3-3.3 3.3h-12.4c-1.8 0-3.3-1.5-3.3-3.3v-12.4c0-1.8 1.5-3.3 3.3-3.3h12.4c1.8 0 3.3 1.5 3.3 3.3z",
  fill: "#223f99"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "m49 114.7c0 1.8-1.5 3.3-3.3 3.3h-12.5c-1.8 0-3.3-1.5-3.3-3.3v-12.4c0-1.8 1.5-3.3 3.3-3.3h12.4c1.8 0 3.3 1.5 3.3 3.3v12.4z",
  fill: "#00adee"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "m72.5 114.7c0 1.8-1.5 3.3-3.3 3.3h-12.4c-1.8 0-3.3-1.5-3.3-3.3v-12.4c0-1.8 1.5-3.3 3.3-3.3h12.4c1.8 0 3.3 1.5 3.3 3.3z",
  fill: "#fff100"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "m96.1 114.7c0 1.8-1.5 3.3-3.3 3.3h-12.5c-1.8 0-3.3-1.5-3.3-3.3v-12.4c0-1.8 1.5-3.3 3.3-3.3h12.4c1.8 0 3.3 1.5 3.3 3.3v12.4z",
  fill: "#9e1f63"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "m39.1 53.7 2.4 4.9 5.4.8-3.9 3.8.9 5.4-4.8-2.5-4.9 2.5 1-5.4-4-3.8 5.4-.8z",
  fill: "#652d90"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "m59.6 91.4-3.5-6 3.5-5.9h6.8l3.5 5.9-3.5 6z",
  fill: "#be1e2d"
});

var _ref17 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 86.3,
  cy: 85.3,
  fill: "#262261",
  rx: 6.8,
  ry: 6.8,
  transform: "matrix(.1587 -.9873 .9873 .1587 -11.6842 156.9683)"
});

var SvgAppDevPhone = function SvgAppDevPhone(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 126 159.3",
    viewBox: "0 0 126 159.3",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAppDevPhone, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/app-dev-phone.b97f7f98.svg";
export { ForwardRef as ReactComponent };